export default __webpack_public_path__ + "static/media/no_photo.7b8c897f.svg";